import React from 'react';
import {
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Breakpoint,
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTranslation } from 'react-i18next';
import { Button } from '../button/button';

interface AlertDialogProps {
  title: string | React.ReactNode;
  open: boolean;
  setOpen: (value: boolean) => void;
  onConfirm?: () => void;
  onDismiss?: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  content: any;
  actions?: boolean;
  maxWidth?: Breakpoint | false;
  fullScreen?: boolean;
}
export function AlertDialog({
  title,
  open,
  setOpen,
  onConfirm,
  onDismiss,
  content,
  actions,
  confirmLabel,
  cancelLabel,
  maxWidth,
  fullScreen,
}: AlertDialogProps) {
  const { t } = useTranslation();
  const handleClose = () => {
    if (onDismiss) {
      onDismiss();
    }
    setOpen(false);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      maxWidth={maxWidth}
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ zIndex: 1300 }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {title}
        <IconButton
          data-testid="closeModal"
          aria-label={t('accessibility.CLOSE')}
          color="inherit"
          size="small"
          onClick={() => {
            handleClose();
          }}
        >
          <CancelIcon fontSize="inherit" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <span id="alert-dialog-description">{content}</span>
      </DialogContent>
      {actions && (
        <DialogActions>
          {cancelLabel && (
            <Button
              type="button"
              color="secondary"
              variant="outlined"
              onClick={handleClose}
              label={cancelLabel}
            />
          )}
          {confirmLabel && (
            <Button
              type="button"
              color="secondary"
              variant="outlined"
              onClick={onConfirm}
              autoFocus
              label={confirmLabel}
            />
          )}
        </DialogActions>
      )}
    </Dialog>
  );
}
